import styled from "styled-components";

const SupportBillingFormStyles = styled.div`
  margin-bottom: 40px;

  .page-title {
    display: none;

    ${props => props.theme.media.lg} {
      display: block;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 36px;
      line-height: 48px;
      color: rgba(18, 23, 36, 0.91);
      margin-top: 16px;
    }
  }

  .page-description {
    margin: 1rem 0;
    margin-bottom: 2.5rem;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    font-feature-settings: 'ss01' on, 'ss02' on, 'ss04' on;
    color: rgba(18, 23, 36, 0.91);

    
    ${props => props.theme.media.lg} {
      max-width: 660px;
      font-size: 14px;
    }
    ${props => props.theme.media.xl} {
      font-size: 16px;
    }
  }

  .col-12 {
    margin-bottom: .5rem;

    ${props => props.theme.media.lg} {
      max-width: 450px;
    }

    .field-control {
      color: rgba(18, 23, 36, 0.91);
    }
  }

  .row {
    ${props => props.theme.media.lg} {
      flex-wrap: initial;
      flex-direction: column;
    }
  }

  .col-12.description-input {
    .label-text {
      color: #6c757d
    }
    .form-control {
      border: 1px solid #bdc5c4;
    }

    ${props => props.theme.media.lg} {
      max-width: 650px;
    }
  }


  label.is-raised {
    .label-text {
      top: 0 !important;
      background-color: white;
      padding: 0px 3px;
    }

    .field-control {
      padding: 0rem 0.5rem 0rem !important;
    }
  }

  .error-notice {
    margin: -5px 1rem 1rem;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.045em;
    color: #DE2644;
  }

  .btn-wrap {
    margin-top: 20px;

    .btn.disabled {
      background-color: #F15F22;
      opacity: 0.25;
    }
  }

  .is-loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(251 250 250 / 10%);
  }

  .case-errors {
    color: red;
  }
`;

export default SupportBillingFormStyles;